var render = function render(_c,_vm){return _c('div',{class:_vm.$style.formRow},[(_vm.slots().left)?_c('div',{class:_vm.$style.left,style:({ width: `${_vm.props.ratio[0] * 100}%` })},[_vm._t("left")],2):_vm._e(),(_vm.slots().right)?_c('div',{class:_vm.$style.right,style:({ width: `${_vm.props.ratio[1] * 100}%` })},[_vm._t("right")],2):_vm._e(),_c('div',{class:_vm.$style.full},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }